module.exports = __webpack_public_path__ + "static/media/BAP9.3bd6decb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP9.png
 ** module id = 687
 ** module chunks = 0
 **/